var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 4.386c0-2.35 2.58-3.788 4.579-2.551l12.3 7.614c1.895 1.173 1.895 3.93 0 5.102l-12.3 7.615c-1.999 1.237-4.58-.2-4.58-2.551V4.385Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;